import React from "react";
import { Grid, Typography } from "@mui/material";
import AttributeCard from "./attribute-card";
import type { TAttribute } from "../schemas";

interface AttributeListProps {
  attributes: TAttribute[];
  onEdit: (attribute: TAttribute) => void;
  onDelete: (attribute: TAttribute) => void;
}

const AttributeList: React.FC<AttributeListProps> = ({
  attributes,
  onEdit,
  onDelete,
}) => {
  if (!attributes || attributes.length === 0) {
    return (
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{ textAlign: "center", mt: 4 }}
      >
        No menu attributes found. Click "Add Attribute" to create one.
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {attributes.map((attribute) => (
        <Grid item xs={12} sm={6} md={6} lg={6} key={attribute._id}>
          <AttributeCard
            attribute={attribute}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AttributeList;
